module.exports = __webpack_public_path__ + "img/trezor.c66f52ae.png";